export const DEFAULT_PAGE_TAKE = 50
